import React, { Component } from "react";
import { Link } from "react-router-dom";
import concat from "lodash/concat";
import { Breadcrumb, Header, Divider } from "semantic-ui-react";

const breadcrumbs = [
  {
    key: "home",
    content: "Dashboard",
    link: true,
    as: Link,
    to: "/"
  }
];

class PageHeader extends Component {
  render() {
    return (
      <div className="page-heading">
        {this.props.breadcrumbs !== false && (
          <Breadcrumb sections={concat(breadcrumbs, this.props.breadcrumbs)} />
        )}
        {this.props.title !== false && (
          <Header as="h1">{this.props.title}
            {this.props.subtitle && (<Header.Subheader>{this.props.subtitle}</Header.Subheader>)}
          </Header>
        )}
        <Divider hidden />
      </div>
    );
  }
}

export default PageHeader;
